import {
    ChatFieldsFragment,
    ClientPhoneFieldsFragment,
    MessageMethod,
    Patient,
} from '~graphql/generated/graphql'
import { PatientIdAndName } from './templates/types'
import { getClientFullName } from '~utils/helpers'

export type MessageWarning = {
    message: string
    type: 'error' | 'warning'
}

export function getEmailedDisabledMessage(
    client?: ChatFieldsFragment['client'],
): string | null {
    if (!client?.email) {
        return 'Client does not have an email address'
    }
    // if (!client?.email_enabled) {
    //     return 'Client has email disabled'
    // }

    // if (
    //     !client?.settings?.client_chckup_notifications_enabled ||
    //     !client?.settings?.clinic_chckup_notifications_enabled
    // ) {
    //     return 'All notifications are disabled for this client.'
    // }

    // if (
    //     !client?.settings?.client_chckup_email_enabled ||
    //     !client?.settings?.clinic_chckup_email_enabled
    // ) {
    //     return 'Email notifications are disabled for this client.'
    // }
    return null
}

export function getSmsDisabledMessage(
    client?: ChatFieldsFragment['client'],
): string | null {
    if (!client?.phone && !client?.client_phones?.length) {
        return 'Client does not have a phone number'
    }
    // if (!client?.sms_enabled) {
    //     return 'Client has SMS disabled'
    // }

    // if (
    //     !client?.settings?.client_chckup_notifications_enabled ||
    //     !client?.settings?.clinic_chckup_notifications_enabled
    // ) {
    //     return 'All notifications are disabled for this client.'
    // }
    // if (
    //     !client?.settings?.client_chckup_sms_enabled ||
    //     !client?.settings?.clinic_chckup_sms_enabled
    // ) {
    //     return 'SMS notifications are disabled for this client.'
    // }

    return null
}

export function getPostcardDisabledMessage(
    client?: ChatFieldsFragment['client'],
): string | null {
    if (!client?.address?.street_a) {
        return 'Client does not have an address on file'
    }
    return null
}

/**
 * Returns warnings for messaging a client based on their settings and subscription status.
 * These warnings are shown before sending to alert the user of potential delivery issues.
 */
export function getClientMessageWarnings(
    client: ChatFieldsFragment['client'] | undefined,
    clinic: ChatFieldsFragment['clinic'] | undefined,
    messageMethods: MessageMethod[],
    selectedPhone?: ClientPhoneFieldsFragment,
): MessageWarning[] {
    if (!client) return []

    const warnings: MessageWarning[] = []

    // Extract ignore_pms_comms_settings from clinic's tmp_feature_flags
    const { ignore_pms_comms_settings } = (clinic?.tmp_feature_flags || {}) as {
        ignore_pms_comms_settings?: boolean
    }

    // Check SMS-related warnings
    if (messageMethods.includes(MessageMethod.Sms)) {
        // Check if selected phone is unsubscribed
        if (selectedPhone?.is_unsubscribed) {
            warnings.push({
                message: `The selected phone number has been unsubscribed from SMS.`,
                type: 'error',
            })
        }

        // Check if SMS is disabled in client settings
        if (client.settings?.client_chckup_sms_enabled === false) {
            warnings.push({
                message: 'This client has disabled SMS notifications.',
                type: 'warning',
            })
        }

        // Check if clinic has disabled SMS for this client
        if (
            client.settings?.clinic_chckup_sms_enabled === false &&
            !ignore_pms_comms_settings
        ) {
            warnings.push({
                message: 'Your clinic has disabled SMS for this client.',
                type: 'warning',
            })
        }

        // Check PMS SMS setting (only if clinic doesn't ignore PMS comms settings)
        // if (client.sms_enabled === false && !ignore_pms_comms_settings) {
        //     warnings.push({
        //         message:
        //             'SMS is disabled for this client in your practice management system.',
        //         type: 'warning',
        //     })
        // }
    }

    // Check Email-related warnings
    if (messageMethods.includes(MessageMethod.Email)) {
        // Check if email is disabled in client settings
        if (
            client.settings?.client_chckup_email_enabled === false ||
            client.is_unsubscribed
        ) {
            warnings.push({
                message: 'This client has disabled email notifications.',
                type: 'warning',
            })
        }

        // Check if clinic has disabled email for this client
        if (
            client.settings?.clinic_chckup_email_enabled === false &&
            !ignore_pms_comms_settings
        ) {
            warnings.push({
                message: 'Your clinic has disabled email for this client.',
                type: 'warning',
            })
        }

        // Check PMS email setting (only if clinic doesn't ignore PMS comms settings)
        // if (client.email_enabled === false && !ignore_pms_comms_settings) {
        //     warnings.push({
        //         message:
        //             'Email is disabled for this client in your practice management system.',
        //         type: 'warning',
        //     })
        // }
    }

    // Check notification settings (applies to both SMS and Email)
    if (
        messageMethods.includes(MessageMethod.Sms) ||
        messageMethods.includes(MessageMethod.Email)
    ) {
        if (client.settings?.client_chckup_notifications_enabled === false) {
            warnings.push({
                message: 'This client has disabled all Chckvet notifications.',
                type: 'warning',
            })
        }

        if (client.settings?.clinic_chckup_notifications_enabled === false) {
            warnings.push({
                message:
                    'Your clinic has disabled all notifications for this client.',
                type: 'warning',
            })
        }
    }

    return warnings
}
